// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"PodContent_noScrolling__9pzfb","carousel":"PodContent_carousel__CGUeD","thumbnail":"PodContent_thumbnail__FLX1V"};